import React, { useState } from 'react';
import './upperbox.css';
import { Link } from 'react-router-dom';

export const Upperbox = () => {
  const [email, setEmail] = useState('info@clasptax.com');

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className='upperbox'>
      <div className='contact-info'>
        <p>Call Us +1 (972)-220-9783</p>
        <b>|</b>
        <p onClick={handleEmailClick}>{email}</p>
      </div>
      <div className='link-container'>
        <Link to='/Referandearnn'  className="text-decoration-none">
          <p className="blinking-text">Refer & Earn</p>
        </Link>
        <b>|</b>
        <Link to='/Signup' className="text-decoration-none">
          <p>Register</p>
        </Link>
        <b>|</b>
        <Link to='/login' className="text-decoration-none">
          <p>Login</p>
        </Link>
      </div>
    </div>
  );
};
